const HotKeyActions = {
  ESCAPE: 'stopCurrentAction',
  GO_MENU: 'goMenu',
};

export default HotKeyActions;
